/**
 *
 * Loader
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';
// import styled from 'styled-components';
import { translate as t } from '../../utils/translator';

import style from './style.module.scss';

function Loader(props) {
  const headerText = props.loadingText
    ? t(props.loadingText, props.language)
    : t('kyc18', props.language);

  return (
    <div className={style.loader}>
      <div className={style.loadingImg} />
      <div className={style.heading}>
        {headerText}
      </div>
      {props.message && <div className={style.subHeading}>{props.message}</div>}
    </div>
  );
}

Loader.propTypes = {
  message: PropTypes.string,
};

const mapStateToProps = state => ({
  language: state.language.language
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(Loader);
